<template>
<ul class="sidebar-menu">


  <!-- <router-link tag="li" class="pageLink" to="/dashboard">
    <a>
      <i class="fa fa-bar-chart" aria-hidden="true"></i>
      <span class="page">Dashboard</span>
    </a>
  </router-link> -->


  <router-link tag="li" class="pageLink" to="/registrations">
    <a>
      <i class="fa fa-envelope" aria-hidden="true"></i>
      <span class="page">Registrations</span>
    </a>
  </router-link>

  <router-link tag="li" class="pageLink" to="/checkpoints">
    <a>
      <i class="fa fa-qrcode" aria-hidden="true"></i>
      <span class="page">QR Code Scanner</span>
    </a>
  </router-link>

  <router-link tag="li" class="pageLink" to="/history">
    <a>
      <i class="fa fa-list" aria-hidden="true"></i>
      <span class="page">Scanner History</span>
    </a>
  </router-link>


</ul>
</template>



<script>
import axios from "axios";
import {
  globalStore
} from '../main.js';
export default {
  name: 'SidebarMenu',
  data: function() {
    return {
      Mobile: "",
      Token: "",
      AccessRights: {
        Dashboard: true,
        Users: true,
        Events: true,
        Checkpoints: true,
        MyVisitors: false,
        AllVisitors: false       
      }
    }
  },
  mounted: function() {

  },
  methods: {

  }
}
</script>

<style>
/* override default */


.sidebar-menu>li>a {
  padding: 12px 15px 12px 15px;
}

.sidebar-menu li.active>a>.fa-angle-left,
.sidebar-menu li.active>a>.pull-right-container>.fa-angle-left {
  animation-name: rotate;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
}

.treeview-title {
  z-index: 1;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-90deg);
  }
}
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?10d09658